//局部引入 echarts
import * as echarts from "echarts";

let option1 = {
	tooltip: {
		trigger: 'axis',
		axisPointer: {
			lineStyle: {
				color: '#dddc6b'
			}
		}
	},
	legend: {
		top: '0%',
		data: ['巡检', '维修'],
		textStyle: {
			color: 'rgba(255,255,255,.5)',
			fontSize: '12',
		}
	},
	grid: {
		left: '30',
		top: '30',
		right: '30',
		bottom: '40',
		containLabel: true
	},

	xAxis: [{
		type: 'category',
		axisLabel: {
			rotate: 50, //标题角度50度
			textStyle: {
				color: "rgba(255,255,255,.6)",
				fontSize: 12,
			},
		},
		axisLine: {
			lineStyle: {
				color: 'rgba(255,255,255,.2)'
			}
		},
		data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']

	}, {

		axisPointer: {
			show: false
		},
		axisLine: {
			show: false
		},
		position: 'bottom',
		offset: 20,
	}],

	yAxis: [{
		type: 'value',
		axisTick: {
			show: false
		},
		axisLine: {
			lineStyle: {
				color: 'rgba(255,255,255,.1)'
			}
		},
		axisLabel: {
			textStyle: {
				color: "rgba(255,255,255,.6)",
				fontSize: 12,
			},
		},

		splitLine: {
			lineStyle: {
				color: 'rgba(255,255,255,.1)'
			}
		}
	}],
	series: [{
			name: '巡检',
			type: 'bar',
			smooth: true,
			symbol: 'circle',
			symbolSize: 5,
			showSymbol: false,
			lineStyle: {
				normal: {
					color: '#0184d5',
					width: 2
				}
			},
			areaStyle: {
				normal: {
					color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
						offset: 0,
						color: 'rgba(1, 132, 213, 0.4)'
					}, {
						offset: 0.8,
						color: 'rgba(1, 132, 213, 0.1)'
					}], false),
					shadowColor: 'rgba(0, 0, 0, 0.1)',
				}
			},
			itemStyle: { //柱体宽度
				normal: {
					color: '#0184d5',
					borderColor: 'rgba(221, 220, 107, .1)',
					borderWidth: 4
				}
			},
			data: [84, 83, 82, 82, 82, 80, 78, 77, 72, 69, 67, 62, 62, 62]
		},
		{
			name: '维修',
			type: 'bar',
			smooth: true,
			symbol: 'circle',
			symbolSize: 5,
			showSymbol: false,
			lineStyle: {

				normal: {
					color: '#e8d348',
					width: 2
				}
			},
			areaStyle: {
				normal: {
					color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
						offset: 0,
						color: 'rgba(0, 216, 135, 0.4)'
					}, {
						offset: 0.8,
						color: 'rgba(0, 216, 135, 0.1)'
					}], false),
					shadowColor: 'rgba(0, 0, 0, 0.1)',
				}
			},
			itemStyle: {
				normal: {
					color: '#f3dd6d',
					borderColor: 'rgba(221, 220, 107, .1)',
					borderWidth: 4
				}
			},
			data: [14, 13, 13, 13, 12, 12, 11, 7, 6, 6, 10, 10]

		},

	]

}


var option2 = {
	color: ['#80FFA5', '#00DDFF', '#37A2FF', '#FF0087', '#FFBF00'],
	tooltip: {
		trigger: 'axis',
		axisPointer: {
			type: 'cross',
			label: {
				backgroundColor: '#6a7985'
			},
			lineStyle: {
				color: '#dddc6b'
			}
		}
	},
	legend: { //图例设置
		data: ['门', '排风机', '	窗', '电闸', '通道'],
		textStyle: {
			color: '#999999',
			fontSize: '12',
		}
	},

	grid: { //图表视图位置
		left: '3%',
		right: '20px',
		bottom: '50px',
		containLabel: true
	},
	xAxis: [{
		type: 'category',
		boundaryGap: false,
		data: ['周一', '周二', '周三', '周四', '周五', '周六', '周日']
	}],
	yAxis: [{
		type: 'value',
		axisLine: { //Y轴坐标（纵轴）
			show: true
		},
		axisTick: { //Y轴刻度
			show: false
		},
		splitLine: { //刻度对应的横轴辅助线
			show: true,
			lineStyle: {
				color: "rgba(255,255,255,.3)"
			}
		}

	}],
	series: [{
			name: '门',
			type: 'line',
			stack: 'Total',
			smooth: true,
			lineStyle: {
				width: 0
			},
			showSymbol: false,
			areaStyle: {
				opacity: 0.8,
				color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
						offset: 0,
						color: 'rgb(128, 255, 165)'
					},
					{
						offset: 1,
						color: 'rgb(1, 191, 236)'
					}
				])
			},
			emphasis: {
				focus: 'series'
			},
			data: [140, 232, 101, 264, 90, 340, 250]
		},
		{
			name: '排风机',
			type: 'line',
			stack: 'Total',
			smooth: true,
			lineStyle: {
				width: 0
			},
			showSymbol: false,
			areaStyle: {
				opacity: 0.8,
				color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
						offset: 0,
						color: 'rgb(0, 221, 255)'
					},
					{
						offset: 1,
						color: 'rgb(77, 119, 255)'
					}
				])
			},
			emphasis: {
				focus: 'series'
			},
			data: [120, 282, 111, 234, 220, 340, 310]
		},
		{
			name: '	窗',
			type: 'line',
			stack: 'Total',
			smooth: true,
			lineStyle: {
				width: 0
			},
			showSymbol: false,
			areaStyle: {
				opacity: 0.8,
				color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
						offset: 0,
						color: 'rgb(55, 162, 255)'
					},
					{
						offset: 1,
						color: 'rgb(116, 21, 219)'
					}
				])
			},
			emphasis: {
				focus: 'series'
			},
			data: [320, 132, 201, 334, 190, 130, 220]
		},
		{
			name: '电闸',
			type: 'line',
			stack: 'Total',
			smooth: true,
			lineStyle: {
				width: 0
			},
			showSymbol: false,
			areaStyle: {
				opacity: 0.8,
				color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
						offset: 0,
						color: 'rgb(255, 0, 135)'
					},
					{
						offset: 1,
						color: 'rgb(135, 0, 157)'
					}
				])
			},
			emphasis: {
				focus: 'series'
			},
			data: [220, 402, 231, 134, 190, 230, 120]
		},
		{
			name: '通道',
			type: 'line',
			stack: 'Total',
			smooth: true,
			lineStyle: {
				width: 0
			},
			showSymbol: false,
			label: {
				show: true,
				position: 'top'
			},
			areaStyle: {
				opacity: 0.8,
				color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
						offset: 0,
						color: 'rgb(255, 191, 0)'
					},
					{
						offset: 1,
						color: 'rgb(224, 62, 76)'
					}
				])
			},
			emphasis: {
				focus: 'series'
			},
			data: [220, 302, 181, 234, 210, 290, 150]
		}
	]
}


//中国地图数据


var data3 = [{
		name: '河北',
		value: 9
	},
	{
		name: '山西',
		value: 112
	},
	{
		name: '辽宁',
		value: 12
	},
	{
		name: '吉林',
		value: 22
	},
	{
		name: '江苏',
		value: 84
	},
	{
		name: '浙江',
		value: 15
	},
	{
		name: '安徽',
		value: 16
	},
	{
		name: '福建',
		value: 68
	},
	{
		name: '江西',
		value: 18
	},
	{
		name: '山东',
		value: 19
	},
	{
		name: '河南',
		value: 91
	},
	{
		name: '湖北',
		value: 21
	},
	{
		name: '湖南',
		value: 21
	},
	{
		name: '广东',
		value: 22
	},
	{
		name: '海南',
		value: 23
	},
	{
		name: '四川',
		value: 34
	},
	{
		name: '贵州',
		value: 24
	},
	{
		name: '云南',
		value: 25
	},
	{
		name: '陕西',
		value: 25
	},
	{
		name: '青海',
		value: 75
	},
	{
		name: '台湾',
		value: 65
	},
	{
		name: '北京',
		value: 85
	},
	{
		name: '天津',
		value: 25
	},
	{
		name: '上海',
		value: 76
	},
	{
		name: '重庆',
		value: 66
	},
	{
		name: '内蒙古',
		value: 26
	},
	{
		name: '广西',
		value: 27
	},
	{
		name: '宁夏',
		value: 127
	},
	{
		name: '新疆',
		value: 177
	},
	{
		name: '香港',
		value: 28
	},
	{
		name: '澳门',
		value: 29
	},
	{
		name: '黑龙江',
		value: 69
	},
	{
		name: '西藏',
		value: 29
	},
	{
		name: '甘肃',
		value: 29
	},

];


var option3 = {
	title: {
		text: '人防分布',
		left: 'center',
		top: '40',
		textStyle: {
			color: '#fff'
		},
		subtext: '人防分布情况',
		subtextStyle: {
			color: '#fff'
		},
	},
	tooltip: {
		triggerOn: "mousemove",
		show: true,
		padding: 5,

	},

	visualMap: { //右下角图例设置
		min: 0,
		max: 1000,
		left: 26,
		bottom: 50,
		showLabel: true,
		pieces: [{
				gt: 120,
				label: "120次巡检以上",
				color: "rgba(26,201,255,.9)",
			},
			{
				gt: 90,
				lt: 120,
				label: "90-120次巡检",
				color: "rgba(26,201,255,.8)",
			},
			{
				gt: 60,
				lt: 90,
				label: "60-90次巡检",
				color: "rgba(26,201,255,.7)",
			},
			{
				gt: 30,
				lt: 60,
				label: "30-60次巡检",
				color: "rgba(26,201,255,.6)",
			},
			{
				lt: 30,
				label: "30次巡检以下",
				color: "rgba(26,201,255,.5)",
			},
		],
		textStyle: {
			color: "#999",
		},
		show: !0,
	},
	geo: {
		map: "china",
		roam: !1,
		scaleLimit: {
			min: 1,
			max: 2.5,
		},
		zoom: 1.00, //地图缩放比例
		top: 70, //地图距离
		label: {//一级行政区域字体设置
			normal: {
				show: !0,
				fontSize: "14",
				color: "#ebebeb", //一级行政区名称颜色
			},
			emphasis: { //区域鼠标悬浮效果
				show: true,
				textStyle: {
					color: "#ffffff",
					fontSize: '16px',
				}
			},
		},
		itemStyle: {
			normal: { //南海诸岛区域
				color: "#4dc8ee",
				shadowBlur: 1,
				shadowColor: "D8BC37",
			},
			emphasis: { //基础行政区域鼠标悬浮样式
				areaColor: '#18bc9c',
				shadowOffsetX: 15,
				shadowOffsetY: 15,
				shadowBlur: 20,
				borderWidth: 1,
				borderColor:'#ffffff',
				shadowColor: "rgba(0, 0, 0, 0.5)",
			},
		},
	},
	layoutCenter: ["30%", "30%"],
	series: [{
		name: "数量",
		type: "map",
		geoIndex: 0,
		data: data3,
		itemStyle: {
			normal: {
				color: '#ffffff'
			}
		}
	}, ],
}



//维保人员排行
var data4 = [13, 11, 10, 10, 6, 3, 2, 1, 1, 1]
var titlename = ['张工', '王工', '李工', '司马工', '林工', '戴工', '杨工', '术工', '凌工', '万工'];

var option4 = {
	grid: {
		left: '20',
		top: '0',
		right: '30',
		bottom: '30',
		containLabel: true
	},
	xAxis: {
		show: false
	},
	yAxis: [{
		show: true,
		data: titlename,
		inverse: true,
		axisLine: {
			show: false
		},
		splitLine: {
			show: false
		},
		axisTick: {
			show: false
		},
		axisLabel: {
			textStyle: {
				color: '#fff'
			},
		},

	}, {
		show: false,
		inverse: true,
		data: data4,
		axisLabel: {
			textStyle: {
				color: '#fff'
			}
		},
		axisLine: {
			show: false
		},
		splitLine: {
			show: false
		},
		axisTick: {
			show: false
		},
	}],
	series: [{
		name: '条',
		type: 'bar',
		yAxisIndex: 0,
		data: data4,
		barWidth: 10,
		itemStyle: {
			normal: {
				barBorderRadius: 50,
				color: new echarts.graphic.LinearGradient(
					0, 0, 1, 0, //0,0,0,0左，上，右、下渐变
					[{
							offset: 0,
							color: '#53cf5b'
						},
						{
							offset: 0.5,
							color: '#f3dd6d'
						},
						{
							offset: 1,
							color: '#ff0000'
						}

					]
				)

			}
		},
		label: {
			normal: {
				show: true,
				position: 'right',
				formatter: '{c}',
				textStyle: {
					color: 'rgba(255,255,255,.5)'
				}
			}
		},
	}]
};



//导出设置使得Vue可引入，关键
export {
	option1,
	option2,
	option3,
	option4
}